var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('div',[_c('h1',[_vm._v("Ошибка доступа")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }